import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  return (
    <section id="categories" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="eyebrow">
            <i className="ri-layout-grid-line" aria-hidden="true"></i>
            主题分类
          </p>
          <h2 className="section-title mt-4">六个入口，按圈层找瓜</h2>
          <p className="mt-4 font-body text-sm leading-relaxed text-foreground-600 md:text-base">
            与其在信息流里翻找，不如从分类进入。每个分类下的档案都按更新时间排序，最近发生的永远在最前面。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/topics?category=${category.id}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors duration-200 hover:border-primary-300 hover:bg-primary-50/40 md:p-6"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-700 transition-colors duration-200 group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={category.icon} aria-hidden="true"></i>
                </span>
                <span className="font-label text-xs text-foreground-500">{category.count} 份档案</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{category.name}</h3>
              <p className="mt-2 flex-1 font-body text-sm leading-relaxed text-foreground-600">
                {category.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-1 font-label text-xs text-primary-600">
                进入分类
                <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}